module.exports = __webpack_public_path__ + "img/icon-city.0f226aba.svg";